import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError, NavigationCancel } from '@angular/router';
import {LoadingIndicatorService} from '../../services';
import {Subscription} from 'rxjs';

const pathOf = (url: string): string => url.split(/[?#]/)[0];

/** Same /v2 or /admin-v2 path, only the query or fragment changes (brief 6, Anton 2026-10-16). */
export function queryOnlyModernNavigation(current: string, next: string): boolean {
    const path = pathOf(next);
    return path === pathOf(current) && /^\/(v2|admin-v2)(\/|$)/.test(path);
}

@Component({
    selector: 'loading-indicator',
    templateUrl: 'loading-indicator.component.html',
    styleUrls: ['loading-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadingIndicatorComponent {
    public loading: boolean = false;
    public changeSubscription: Subscription;

    constructor(
        private router: Router,
        private service: LoadingIndicatorService,
    ) {
        router.events.subscribe((routerEvent: Event) => {
            this.checkRouterEvent(routerEvent);
        });
    }

    public ngOnInit(): void {
        this.changeSubscription = this.service.onChange.subscribe((isShow) => {
            this.loading = !!isShow
        });
    }

    checkRouterEvent(routerEvent: Event): void {
        if (routerEvent instanceof NavigationStart) {
            // A v2 or Admin v2 page writing its own query (typing in a search box, a filter, rows
            // loaded) loads no page: no bar across the top, or the page looks as if it reloads.
            if (!queryOnlyModernNavigation(this.router.url, routerEvent.url)) {
                this.loading = true;
            }
        }

        if (routerEvent instanceof NavigationEnd ||
            routerEvent instanceof NavigationCancel ||
            routerEvent instanceof NavigationError) {
            this.loading = false;
        }
    }

    public ngOnDestroy() {
        this.changeSubscription.unsubscribe();
    }
}
